import { useCssTokens } from '../../hooks/useCssTokens';

const spaceScale = [
  { token: 'space-0', label: '0' },
  { token: 'space-1', label: '4' },
  { token: 'space-2', label: '8' },
  { token: 'space-3', label: '12' },
  { token: 'space-4', label: '16' },
  { token: 'space-5', label: '20' },
  { token: 'space-6', label: '24' },
  { token: 'space-7', label: '32' },
  { token: 'space-8', label: '40' },
  { token: 'space-9', label: '48' },
  { token: 'space-10', label: '64' },
  { token: 'space-11', label: '80' },
];

const sizingTokens = [
  { token: 'control-height-sm', label: 'Control height sm' },
  { token: 'control-height-md', label: 'Control height md' },
  { token: 'control-height-lg', label: 'Control height lg' },
  { token: 'touch-target-min', label: 'Touch target min' },
];

const paddingTokens = [
  { token: 'control-padding-x-sm', label: 'Padding x sm' },
  { token: 'control-padding-y-sm', label: 'Padding y sm' },
  { token: 'control-padding-x', label: 'Padding x md' },
  { token: 'control-padding-y', label: 'Padding y md' },
  { token: 'control-padding-x-lg', label: 'Padding x lg' },
  { token: 'control-padding-y-lg', label: 'Padding y lg' },
];

const iconTokens = [
  { token: 'icon-size-sm', label: 'Icon sm' },
  { token: 'icon-size-md', label: 'Icon md' },
  { token: 'icon-size-lg', label: 'Icon lg' },
  { token: 'icon-size-xl', label: 'Icon xl' },
];

const spacingTokens = [
  ...spaceScale.map((item) => item.token),
  ...sizingTokens.map((item) => item.token),
  ...paddingTokens.map((item) => item.token),
  ...iconTokens.map((item) => item.token),
];

export function SpacingShowcase() {
  const values = useCssTokens(spacingTokens);

  return (
    <div className="space-y-8">
      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground">Spacing scale</h4>
        <div className="space-y-2">
          {spaceScale.map((item) => (
            <div key={item.token} className="flex items-center gap-4">
              <div className="w-20 text-xs font-semibold text-foreground">{item.label}</div>
              <div className="flex-1">
                <div
                  className="h-3 rounded-full bg-primary/20"
                  style={{ width: values[item.token] || '0px' }}
                />
              </div>
              <div className="w-20 text-xs text-muted-foreground">{values[item.token]}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground">Control sizing</h4>
        <div className="grid grid-cols-4 gap-3">
          {sizingTokens.map((item) => (
            <div key={item.token} className="flex flex-col items-center rounded-2xl border border-border/40 p-3">
              <div
                className="w-full rounded-lg bg-muted"
                style={{ height: values[item.token] || '0px' }}
              />
              <p className="mt-2 text-xs font-medium text-foreground">
                {item.label}
              </p>
              <p className="text-xs text-muted-foreground">{values[item.token]}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground">Control padding</h4>
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
          {paddingTokens.map((item) => (
            <div key={item.token} className="rounded-2xl border border-border/40 p-3 text-center">
              <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
                {item.label}
              </p>
              <p className="mt-1 text-sm font-medium text-foreground">{values[item.token]}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-semibold text-foreground">Icon sizing</h4>
        <div className="grid grid-cols-4 gap-3">
          {iconTokens.map((item) => (
            <div key={item.token} className="flex flex-col items-center rounded-2xl border border-border/40 p-3">
              <div
                className="rounded-lg bg-primary/20"
                style={{
                  width: values[item.token] || '20px',
                  height: values[item.token] || '20px',
                }}
              />
              <p className="mt-2 text-xs font-medium uppercase tracking-[0.15em] text-foreground">
                {item.label}
              </p>
              <p className="text-xs text-muted-foreground">{values[item.token]}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
